import type { CSSProperties } from "react";
import { amountText, type DuelView, verdictAt } from "./duel";
import { Check, Cross } from "./icons";
import "./duel.css";

/** After the game: the whole chain as flag bands, a ✓/✗ badge on each seam. */
export function DuelRecap({ view }: { view: DuelView }) {
  const m = view.metric;
  const won = view.correct >= view.winAt;
  return (
    <div className="du-recap">
      <div className="du-recap-head">
        <span>
          {m.icon} {m.label}
        </span>
        <span>
          вгадано <b data-won={won}>{view.correct} з {view.total}</b>
        </span>
      </div>
      <ol className="du-ladder">
        {view.rounds.map((r, i) => {
          const v = i > 0 ? verdictAt(view, i - 1) : null;
          return (
            <li key={r.code} className="du-rung" style={{ "--i": i } as CSSProperties}>
              <span className="du-rung-bg">
                <img src={`/flags/${r.code.toLowerCase()}.svg`} alt="" draggable={false} />
              </span>
              <span className="du-rung-name">{r.name}</span>
              <span className="du-rung-val">{r.val !== undefined ? amountText(m.key, r.val) : "?"}</span>
              {v !== null && (
                <span className={`du-mark ${v ? "du-mark-ok" : "du-mark-bad"}`} role="img" aria-label={v ? "вгадано" : "не вгадано"}>
                  {v ? <Check /> : <Cross />}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
